// a shitty placeholder for a Popup refactoring which
// - separates usage as modal (shown in the middle, blocking everything else, closing with X button) from dropdown (attached to content, non-blocking, closing by outside click)
// - uses newer styles and most common settings by default
// - provides easier configuration for titles and buttons

import { PureComponent, ComponentEventHandler } from 'typed/components/utils';
import { ReactElement } from 'react';
import { Resource } from '../FormattedResource/FormattedResource';
import Popup from 'components/common/Popup/Popup';
import EntityEditForm from 'components/common/EntityEditForm/EntityEditForm';
import './Window.less';

interface Props /* extends Popup props*/ {
    title: Resource;
    close?: Resource;
    additionalButtons?: (ReactElement | { // TODO a buttons component which accepts resource as a content? there are virtually no other usages in the application
        name: Resource;
        opposite?: boolean;
        disabled?: boolean;
        className?: boolean;
        onClick?: ComponentEventHandler;
    })[];
    className?: string;

    onClose?: ComponentEventHandler;
}

export default class Window extends PureComponent<Props, {}> {
    static readonly defaultProps = {
        close: { id: 'common.close' },
        closeMode: Popup.CloseMode.CLOSE_BUTTON,
        dimmed: true,
        className: ''
    };

    render() {
        const { title, close, additionalButtons, className, children, ...popupProps } = this.props;

        return (
            <Popup {...popupProps} className={'window new ' + className}>
                <EntityEditForm
                    title={title}
                    submit={close}
                    cancel={null}
                    additionalButtons={additionalButtons}
                    onSubmit={this.props.onClose}>
                    {children}
                </EntityEditForm>
            </Popup>
        );
    }
}